'use client';

import { Box, Flex } from '@chakra-ui/react';
import Image from 'next/image';

const BRANDS = Array.from({ length: 21 }, (_, i) => i + 1);
// Duplicate for seamless infinite loop
const TRACK = [...BRANDS, ...BRANDS];

const BrandCarrossel = () => {
  return (
    <>
      <style>{`
        @keyframes brand-march {
          0%   { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }
        .brand-track {
          animation: brand-march 38s linear infinite;
          will-change: transform;
        }
        .brand-marquee:hover .brand-track {
          animation-play-state: paused;
        }
      `}</style>

      <Box
        className="brand-marquee"
        pos="relative"
        w="100%"
        h={{ base: '104px', md: '128px' }}
        overflow="hidden"
        borderRadius="20px"
        border="2px solid"
        borderColor="rgba(0,176,202,0.18)"
        boxShadow="0 8px 40px rgba(0,0,0,0.32), inset 0 1px 0 rgba(255,255,255,0.04)"
        style={{
          background:
            'linear-gradient(160deg, #060F1C 0%, #0A1B2B 45%, #071523 100%)',
        }}
      >
        {/* Ambient glow */}
        <Box
          pos="absolute"
          inset="0"
          pointerEvents="none"
          style={{
            background:
              'radial-gradient(ellipse at 10% 50%, rgba(0,176,202,0.12) 0%, transparent 45%), radial-gradient(ellipse at 90% 50%, rgba(0,176,202,0.08) 0%, transparent 45%), radial-gradient(ellipse at 50% 100%, rgba(0,176,202,0.06) 0%, transparent 60%)',
          }}
        />

        {/* Top shimmer */}
        <Box
          pos="absolute"
          top="0" left="0" right="0" h="1px"
          style={{ background: 'linear-gradient(to right, transparent 0%, rgba(0,176,202,0.8) 50%, transparent 100%)' }}
        />


        {/* Left fade mask */}
        <Box
          pos="absolute"
          left="0" top="0" bottom="0"
          w="80px"
          zIndex={2}
          pointerEvents="none"
          style={{ background: 'linear-gradient(to right, #07111C 0%, transparent 100%)' }}
        />
        {/* Right fade mask */}
        <Box
          pos="absolute"
          right="0" top="0" bottom="0"
          w="80px"
          zIndex={2}
          pointerEvents="none"
          style={{ background: 'linear-gradient(to left, #07111C 0%, transparent 100%)' }}
        />

        {/* Marquee track */}
        <Flex
          className="brand-track"
          align="center"
          h="full"
          style={{ width: 'max-content' }}
          gap="0"
        >
          {TRACK.map((id, i) => (
            <Flex
              key={i}
              align="center"
              justify="center"
              flexShrink={0}
              style={{ width: '160px', height: '100%', padding: '12px 20px' }}
            >
              <Image
                src={`/brands/${id}.svg`}
                height={104}
                width={140}
                alt={`Marca ${id}`}
                style={{
                  objectFit: 'contain',
                  filter: 'brightness(0) invert(1)',
                  opacity: 0.72,
                  width: '100%',
                  height: '100%',
                  maxHeight: '104px',
                  transition: 'opacity 0.2s',
                }}
              />
            </Flex>
          ))}
        </Flex>

        {/* Bottom shimmer */}
        <Box
          pos="absolute"
          bottom="0" left="0" right="0" h="1px"
          style={{ background: 'linear-gradient(to right, transparent 0%, rgba(0,176,202,0.35) 50%, transparent 100%)' }}
        />
      </Box>
    </>
  );
};

export default BrandCarrossel;

